import React, { useEffect, useState } from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const UserDetailDashboard = () => {
    const [userData, setUserData] = useState(null);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || ""
    console.log(token)
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const res = await response.json();
                setUserData(res.users);
            } catch (error) {
                console.error("Failed to fetch user:", error);
            }
        };

        fetchUserData();
    }, [isLoggedIn.main_id, url]);

    if (!userData) return <p className="text-gray-600 text-sm">Loading user info...</p>;

    return (
        <div className="mb-6">
            <h2 className="text-[18px] font-semibold text-gray-800">
                Welcome back, <span className="text-blue-600">{userData.full_name}</span> 👋
            </h2>
            <p className="text-sm text-gray-500 mt-[5px]">
                Here’s a quick overview of your dashboard activity.
            </p>
        </div>
    );
};

export default UserDetailDashboard;
